// extracted by mini-css-extract-plugin
export default {"container":"Root_container__xD0NI","content":"Root_content__clckU"};